<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul class="metismenu list-unstyled" style="padding: 0rem 1.5rem;">
      <span
        *ngIf="envName"
        class="env-badge dev-badge link-custom-primary"
        
      >
        {{ envName }}
      </span>
    </ul>
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <!-- {{menuItems}} -->
      <ng-container *ngFor="let item of sideBarMenuItem">
        <li *ngIf="item.title">
          <a
            *ngIf="hasItems(item)"
            href="javascript:void(0);"
            class="is-parent"
            [ngClass]="{
              'has-arrow': item.subCategories.length > 0,
              'has-dropdown': item.subCategories.length == 0
            }"
          >
            <i class="bx {{ item.icon }}" *ngIf="item.icon"></i>
            <span> {{ item.title }}</span>
            <span
              class="badge rounded-pill float-end bg-custom-primary"
              *ngIf="item.unreadCount"
              >{{ item.unreadCount }}</span
            >
          </a>

          <a
            [routerLink]="item.pageUrl"
            *ngIf="!hasItems(item)"
            class="side-nav-link-ref"
            routerLinkActive="active"
          >
            <i class="bx {{ item.icon }}" *ngIf="item.icon"></i>
            <span> {{ item.title }}</span>
            <span
              class="badge rounded-pill bg-custom-primary float-end"
              *ngIf="item.unreadCount"
              >{{ item.unreadCount }}</span
            >
          </a>
          <ul
            recursive
            [children]="item.subCategories"
            *ngIf="hasItems(item)"
            class="sub-menu"
            aria-expanded="false"
          ></ul>
        </li>
      </ng-container>
      <!-- <li *ngIf="loginType == 'CUSTOMER' && getEstimate">
        <a
          class="side-nav-link-ref mt-5"
          [routerLink]="'/user/transaction/create-transaction'"
          routerLinkActive="active"
        >
          <span class="bg-custom-primary p-2 rounded-2"> Send Money</span>
        </a>
      </li> -->
    </ul>
  </div>
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    <div *ngIf="!isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </ngx-simplebar>
</div>
<!-- Left Sidebar End -->
